(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["quantity-bundle"] && !Shopify.designMode) return;
  try {
    class QuantityBundle extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.form = this.querySelector('.quantity-bundle__form');
      this.tiers = [...this.querySelectorAll('.quantity-bundle__tier')];
      this.ctaPrice = this.querySelector('[ref="ctaPrice"]');
      this.cta = this.querySelector('.quantity-bundle__cta');
      this.errorEl = this.querySelector('.quantity-bundle__error');

      this.addEventListener('change', (event) => {
        if (event.target instanceof HTMLInputElement && event.target.classList.contains('quantity-bundle__radio')) {
          this.select(Number(event.target.value));
        }
      }, { signal });
      this.form?.addEventListener('submit', (event) => this.submit(event), { signal });

      const checked = this.querySelector('.quantity-bundle__radio:checked');
      this.select(checked instanceof HTMLInputElement ? Number(checked.value) : 1);
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    /** @param {number} count */
    select(count) {
      for (const tier of this.tiers) {
        const isSelected = Number(tier.dataset.tier) === count;
        tier.classList.toggle('is-selected', isSelected);
        const items = tier.querySelector('.quantity-bundle__items');
        if (items instanceof HTMLElement) {
          items.hidden = !isSelected;
          // Only the selected tier's inputs are sent with the form.
          for (const input of items.querySelectorAll('input')) {
            if (input.closest('.is-unavailable')) continue;
            input.disabled = !isSelected;
          }
        }
        if (isSelected && this.ctaPrice) this.ctaPrice.textContent = tier.dataset.price ?? '';
      }
    }

    /** @param {SubmitEvent} event */
    async submit(event) {
      event.preventDefault();
      if (!(this.form instanceof HTMLFormElement) || !this.cta) return;

      const data = new FormData(this.form);
      /** @type {Map<string, number>} */
      const counts = new Map();
      for (const [key, value] of data.entries()) {
        if (/^items\[\d+\]\[id\]$/.test(key)) {
          const id = String(value);
          counts.set(id, (counts.get(id) ?? 0) + 1);
        }
      }
      if (counts.size === 0) return;

      const items = [...counts].map(([id, quantity]) => ({ id: Number(id), quantity }));
      this.cta.setAttribute('aria-busy', 'true');
      this.cta.disabled = true;
      if (this.errorEl) this.errorEl.hidden = true;

      try {
        const root = window.Shopify?.routes?.root ?? '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.description || body.message || this.dataset.error);
        }
        window.location.href = this.dataset.checkoutUrl || '/checkout';
      } catch (error) {
        if (this.errorEl) {
          this.errorEl.textContent = error instanceof Error && error.message ? error.message : (this.dataset.error ?? '');
          this.errorEl.hidden = false;
        }
        this.cta.disabled = false;
        this.cta.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('quantity-bundle')) customElements.define('quantity-bundle', QuantityBundle);
  } catch(e) { console.error(e); }
})();

})();
